var endpointMap = {
	ar: {
		"com.amazon.lens.cpr.common.common": "translation-ar.json",
		"com.amazon.lens.cpr.common.menu": "translation-ar.json",
		"com.amazon.lens.cpr.common.message": "translation-ar.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-ar.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-ar.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-ar.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-ar.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-ar.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-ar.json"
	},
	"ar-AE": {
		"com.amazon.lens.cpr.common.common": "translation-ar.json",
		"com.amazon.lens.cpr.common.menu": "translation-ar.json",
		"com.amazon.lens.cpr.common.message": "translation-ar.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-ar.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-ar.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-ar.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-ar.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-ar.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-ar.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-ar.json"
	},
	bn: {
		"com.amazon.lens.cpr.common.common": "translation-bn.json",
		"com.amazon.lens.cpr.common.menu": "translation-bn.json",
		"com.amazon.lens.cpr.common.message": "translation-bn.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-bn.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-bn.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-bn.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-bn.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-bn.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-bn.json"
	},
	"bn-IN": {
		"com.amazon.lens.cpr.common.common": "translation-bn.json",
		"com.amazon.lens.cpr.common.menu": "translation-bn.json",
		"com.amazon.lens.cpr.common.message": "translation-bn.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-bn.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-bn.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-bn.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-bn.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-bn.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-bn.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-bn.json"
	},
	de: {
		"com.amazon.lens.cpr.common.common": "translation-de.json",
		"com.amazon.lens.cpr.common.menu": "translation-de.json",
		"com.amazon.lens.cpr.common.message": "translation-de.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-de.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-de.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-de.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-de.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-de.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-de.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-de.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-de.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-de.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-de.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-de.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-de.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-de.json"
	},
	"de-DE": {
		"com.amazon.lens.cpr.common.common": "translation-de.json",
		"com.amazon.lens.cpr.common.menu": "translation-de.json",
		"com.amazon.lens.cpr.common.message": "translation-de.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-de.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-de.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-de.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-de.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-de.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-de.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-de.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-de.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-de.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-de.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-de.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-de.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-de.json"
	},
	en: {
		"com.amazon.lens.cpr.common.common": "translation-en.json",
		"com.amazon.lens.cpr.common.menu": "translation-en.json",
		"com.amazon.lens.cpr.common.message": "translation-en.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-en.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-en.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-en.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-en.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-en.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-en.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-en.json"
	},
	"en-AU": {
		"com.amazon.lens.cpr.common.common": "translation-en.json",
		"com.amazon.lens.cpr.common.menu": "translation-en.json",
		"com.amazon.lens.cpr.common.message": "translation-en.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-en.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-en.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-en.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-en.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-en.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-en.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-en.json"
	},
	"en-CA": {
		"com.amazon.lens.cpr.common.common": "translation-en.json",
		"com.amazon.lens.cpr.common.menu": "translation-en.json",
		"com.amazon.lens.cpr.common.message": "translation-en.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-en.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-en.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-en.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-en.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-en.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-en.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-en.json"
	},
	"en-GB": {
		"com.amazon.lens.cpr.common.common": "translation-en.json",
		"com.amazon.lens.cpr.common.menu": "translation-en.json",
		"com.amazon.lens.cpr.common.message": "translation-en.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-en.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-en.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-en.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-en.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-en.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-en.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-en.json"
	},
	"en-IE": {
		"com.amazon.lens.cpr.common.common": "translation-en.json",
		"com.amazon.lens.cpr.common.menu": "translation-en.json",
		"com.amazon.lens.cpr.common.message": "translation-en.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-en.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-en.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-en.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-en.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-en.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-en.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-en.json"
	},
	"en-IN": {
		"com.amazon.lens.cpr.common.common": "translation-en.json",
		"com.amazon.lens.cpr.common.menu": "translation-en.json",
		"com.amazon.lens.cpr.common.message": "translation-en.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-en.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-en.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-en.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-en.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-en.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-en.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-en.json"
	},
	"en-SG": {
		"com.amazon.lens.cpr.common.common": "translation-en.json",
		"com.amazon.lens.cpr.common.menu": "translation-en.json",
		"com.amazon.lens.cpr.common.message": "translation-en.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-en.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-en.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-en.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-en.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-en.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-en.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-en.json"
	},
	"en-US": {
		"com.amazon.lens.cpr.common.common": "translation-en.json",
		"com.amazon.lens.cpr.common.menu": "translation-en.json",
		"com.amazon.lens.cpr.common.message": "translation-en.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-en.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-en.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-en.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-en.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-en.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-en.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-en.json"
	},
	"en-ZA": {
		"com.amazon.lens.cpr.common.common": "translation-en.json",
		"com.amazon.lens.cpr.common.menu": "translation-en.json",
		"com.amazon.lens.cpr.common.message": "translation-en.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-en.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-en.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-en.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-en.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-en.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-en.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-en.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-en.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-en.json"
	},
	es: {
		"com.amazon.lens.cpr.common.common": "translation-es.json",
		"com.amazon.lens.cpr.common.menu": "translation-es.json",
		"com.amazon.lens.cpr.common.message": "translation-es.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-es.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-es.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-es.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-es.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-es.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-es.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-es.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-es.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-es.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-es.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-es.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-es.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-es.json"
	},
	"es-ES": {
		"com.amazon.lens.cpr.common.common": "translation-es.json",
		"com.amazon.lens.cpr.common.menu": "translation-es.json",
		"com.amazon.lens.cpr.common.message": "translation-es.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-es.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-es.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-es.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-es.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-es.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-es.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-es.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-es.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-es.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-es.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-es.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-es.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-es.json"
	},
	"es-MX": {
		"com.amazon.lens.cpr.common.common": "translation-es.json",
		"com.amazon.lens.cpr.common.menu": "translation-es.json",
		"com.amazon.lens.cpr.common.message": "translation-es.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-es.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-es.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-es.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-es.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-es.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-es.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-es.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-es.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-es.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-es.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-es.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-es.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-es.json"
	},
	fr: {
		"com.amazon.lens.cpr.common.common": "translation-fr.json",
		"com.amazon.lens.cpr.common.menu": "translation-fr.json",
		"com.amazon.lens.cpr.common.message": "translation-fr.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-fr.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-fr.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-fr.json"
	},
	"fr-BE": {
		"com.amazon.lens.cpr.common.common": "translation-fr.json",
		"com.amazon.lens.cpr.common.menu": "translation-fr.json",
		"com.amazon.lens.cpr.common.message": "translation-fr.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-fr.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-fr.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-fr.json"
	},
	"fr-CA": {
		"com.amazon.lens.cpr.common.common": "translation-fr.json",
		"com.amazon.lens.cpr.common.menu": "translation-fr.json",
		"com.amazon.lens.cpr.common.message": "translation-fr.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-fr.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-fr.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-fr.json"
	},
	"fr-FR": {
		"com.amazon.lens.cpr.common.common": "translation-fr.json",
		"com.amazon.lens.cpr.common.menu": "translation-fr.json",
		"com.amazon.lens.cpr.common.message": "translation-fr.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-fr.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-fr.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-fr.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-fr.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-fr.json"
	},
	gu: {
		"com.amazon.lens.cpr.common.common": "translation-gu.json",
		"com.amazon.lens.cpr.common.menu": "translation-gu.json",
		"com.amazon.lens.cpr.common.message": "translation-gu.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-gu.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-gu.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-gu.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-gu.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-gu.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-gu.json"
	},
	"gu-IN": {
		"com.amazon.lens.cpr.common.common": "translation-gu.json",
		"com.amazon.lens.cpr.common.menu": "translation-gu.json",
		"com.amazon.lens.cpr.common.message": "translation-gu.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-gu.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-gu.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-gu.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-gu.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-gu.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-gu.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-gu.json"
	},
	hi: {
		"com.amazon.lens.cpr.common.common": "translation-hi.json",
		"com.amazon.lens.cpr.common.menu": "translation-hi.json",
		"com.amazon.lens.cpr.common.message": "translation-hi.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-hi.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-hi.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-hi.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-hi.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-hi.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-hi.json"
	},
	"hi-IN": {
		"com.amazon.lens.cpr.common.common": "translation-hi.json",
		"com.amazon.lens.cpr.common.menu": "translation-hi.json",
		"com.amazon.lens.cpr.common.message": "translation-hi.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-hi.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-hi.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-hi.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-hi.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-hi.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-hi.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-hi.json"
	},
	it: {
		"com.amazon.lens.cpr.common.common": "translation-it.json",
		"com.amazon.lens.cpr.common.menu": "translation-it.json",
		"com.amazon.lens.cpr.common.message": "translation-it.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-it.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-it.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-it.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-it.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-it.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-it.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-it.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-it.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-it.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-it.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-it.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-it.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-it.json"
	},
	"it-IT": {
		"com.amazon.lens.cpr.common.common": "translation-it.json",
		"com.amazon.lens.cpr.common.menu": "translation-it.json",
		"com.amazon.lens.cpr.common.message": "translation-it.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-it.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-it.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-it.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-it.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-it.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-it.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-it.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-it.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-it.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-it.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-it.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-it.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-it.json"
	},
	ja: {
		"com.amazon.lens.cpr.common.common": "translation-ja.json",
		"com.amazon.lens.cpr.common.menu": "translation-ja.json",
		"com.amazon.lens.cpr.common.message": "translation-ja.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-ja.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-ja.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-ja.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-ja.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-ja.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-ja.json"
	},
	"ja-JP": {
		"com.amazon.lens.cpr.common.common": "translation-ja.json",
		"com.amazon.lens.cpr.common.menu": "translation-ja.json",
		"com.amazon.lens.cpr.common.message": "translation-ja.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-ja.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-ja.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-ja.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-ja.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-ja.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-ja.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-ja.json"
	},
	kn: {
		"com.amazon.lens.cpr.common.common": "translation-kn.json",
		"com.amazon.lens.cpr.common.menu": "translation-kn.json",
		"com.amazon.lens.cpr.common.message": "translation-kn.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-kn.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-kn.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-kn.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-kn.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-kn.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-kn.json"
	},
	"kn-IN": {
		"com.amazon.lens.cpr.common.common": "translation-kn.json",
		"com.amazon.lens.cpr.common.menu": "translation-kn.json",
		"com.amazon.lens.cpr.common.message": "translation-kn.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-kn.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-kn.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-kn.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-kn.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-kn.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-kn.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-kn.json"
	},
	ko: {
		"com.amazon.lens.cpr.common.common": "translation-ko.json",
		"com.amazon.lens.cpr.common.menu": "translation-ko.json",
		"com.amazon.lens.cpr.common.message": "translation-ko.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-ko.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-ko.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-ko.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-ko.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-ko.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-ko.json"
	},
	"ko-KR": {
		"com.amazon.lens.cpr.common.common": "translation-ko.json",
		"com.amazon.lens.cpr.common.menu": "translation-ko.json",
		"com.amazon.lens.cpr.common.message": "translation-ko.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-ko.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-ko.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-ko.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-ko.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-ko.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-ko.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-ko.json"
	},
	ml: {
		"com.amazon.lens.cpr.common.common": "translation-ml.json",
		"com.amazon.lens.cpr.common.menu": "translation-ml.json",
		"com.amazon.lens.cpr.common.message": "translation-ml.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-ml.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-ml.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-ml.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-ml.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-ml.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-ml.json"
	},
	"ml-IN": {
		"com.amazon.lens.cpr.common.common": "translation-ml.json",
		"com.amazon.lens.cpr.common.menu": "translation-ml.json",
		"com.amazon.lens.cpr.common.message": "translation-ml.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-ml.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-ml.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-ml.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-ml.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-ml.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-ml.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-ml.json"
	},
	mr: {
		"com.amazon.lens.cpr.common.common": "translation-mr.json",
		"com.amazon.lens.cpr.common.menu": "translation-mr.json",
		"com.amazon.lens.cpr.common.message": "translation-mr.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-mr.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-mr.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-mr.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-mr.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-mr.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-mr.json"
	},
	"mr-IN": {
		"com.amazon.lens.cpr.common.common": "translation-mr.json",
		"com.amazon.lens.cpr.common.menu": "translation-mr.json",
		"com.amazon.lens.cpr.common.message": "translation-mr.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-mr.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-mr.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-mr.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-mr.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-mr.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-mr.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-mr.json"
	},
	nl: {
		"com.amazon.lens.cpr.common.common": "translation-nl.json",
		"com.amazon.lens.cpr.common.menu": "translation-nl.json",
		"com.amazon.lens.cpr.common.message": "translation-nl.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-nl.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-nl.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-nl.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-nl.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-nl.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-nl.json"
	},
	"nl-BE": {
		"com.amazon.lens.cpr.common.common": "translation-nl.json",
		"com.amazon.lens.cpr.common.menu": "translation-nl.json",
		"com.amazon.lens.cpr.common.message": "translation-nl.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-nl.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-nl.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-nl.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-nl.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-nl.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-nl.json"
	},
	"nl-NL": {
		"com.amazon.lens.cpr.common.common": "translation-nl.json",
		"com.amazon.lens.cpr.common.menu": "translation-nl.json",
		"com.amazon.lens.cpr.common.message": "translation-nl.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-nl.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-nl.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-nl.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-nl.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-nl.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-nl.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-nl.json"
	},
	pl: {
		"com.amazon.lens.cpr.common.common": "translation-pl.json",
		"com.amazon.lens.cpr.common.menu": "translation-pl.json",
		"com.amazon.lens.cpr.common.message": "translation-pl.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-pl.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-pl.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-pl.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-pl.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-pl.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-pl.json"
	},
	"pl-PL": {
		"com.amazon.lens.cpr.common.common": "translation-pl.json",
		"com.amazon.lens.cpr.common.menu": "translation-pl.json",
		"com.amazon.lens.cpr.common.message": "translation-pl.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-pl.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-pl.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-pl.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-pl.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-pl.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-pl.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-pl.json"
	},
	pt: {
		"com.amazon.lens.cpr.common.common": "translation-pt.json",
		"com.amazon.lens.cpr.common.menu": "translation-pt.json",
		"com.amazon.lens.cpr.common.message": "translation-pt.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-pt.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-pt.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-pt.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-pt.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-pt.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-pt.json"
	},
	"pt-BR": {
		"com.amazon.lens.cpr.common.common": "translation-pt.json",
		"com.amazon.lens.cpr.common.menu": "translation-pt.json",
		"com.amazon.lens.cpr.common.message": "translation-pt.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-pt.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-pt.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-pt.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-pt.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-pt.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-pt.json"
	},
	"pt-PT": {
		"com.amazon.lens.cpr.common.common": "translation-pt.json",
		"com.amazon.lens.cpr.common.menu": "translation-pt.json",
		"com.amazon.lens.cpr.common.message": "translation-pt.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-pt.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-pt.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-pt.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-pt.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-pt.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-pt.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-pt.json"
	},
	sv: {
		"com.amazon.lens.cpr.common.common": "translation-sv.json",
		"com.amazon.lens.cpr.common.menu": "translation-sv.json",
		"com.amazon.lens.cpr.common.message": "translation-sv.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-sv.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-sv.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-sv.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-sv.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-sv.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-sv.json"
	},
	"sv-SE": {
		"com.amazon.lens.cpr.common.common": "translation-sv.json",
		"com.amazon.lens.cpr.common.menu": "translation-sv.json",
		"com.amazon.lens.cpr.common.message": "translation-sv.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-sv.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-sv.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-sv.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-sv.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-sv.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-sv.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-sv.json"
	},
	ta: {
		"com.amazon.lens.cpr.common.common": "translation-ta.json",
		"com.amazon.lens.cpr.common.menu": "translation-ta.json",
		"com.amazon.lens.cpr.common.message": "translation-ta.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-ta.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-ta.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-ta.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-ta.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-ta.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-ta.json"
	},
	"ta-IN": {
		"com.amazon.lens.cpr.common.common": "translation-ta.json",
		"com.amazon.lens.cpr.common.menu": "translation-ta.json",
		"com.amazon.lens.cpr.common.message": "translation-ta.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-ta.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-ta.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-ta.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-ta.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-ta.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-ta.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-ta.json"
	},
	te: {
		"com.amazon.lens.cpr.common.common": "translation-te.json",
		"com.amazon.lens.cpr.common.menu": "translation-te.json",
		"com.amazon.lens.cpr.common.message": "translation-te.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-te.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-te.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-te.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-te.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-te.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-te.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-te.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-te.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-te.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-te.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-te.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-te.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-te.json"
	},
	"te-IN": {
		"com.amazon.lens.cpr.common.common": "translation-te.json",
		"com.amazon.lens.cpr.common.menu": "translation-te.json",
		"com.amazon.lens.cpr.common.message": "translation-te.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-te.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-te.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-te.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-te.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-te.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-te.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-te.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-te.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-te.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-te.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-te.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-te.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-te.json"
	},
	th: {
		"com.amazon.lens.cpr.common.common": "translation-th.json",
		"com.amazon.lens.cpr.common.menu": "translation-th.json",
		"com.amazon.lens.cpr.common.message": "translation-th.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-th.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-th.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-th.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-th.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-th.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-th.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-th.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-th.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-th.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-th.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-th.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-th.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-th.json"
	},
	"th-TH": {
		"com.amazon.lens.cpr.common.common": "translation-th.json",
		"com.amazon.lens.cpr.common.menu": "translation-th.json",
		"com.amazon.lens.cpr.common.message": "translation-th.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-th.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-th.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-th.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-th.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-th.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-th.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-th.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-th.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-th.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-th.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-th.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-th.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-th.json"
	},
	tr: {
		"com.amazon.lens.cpr.common.common": "translation-tr.json",
		"com.amazon.lens.cpr.common.menu": "translation-tr.json",
		"com.amazon.lens.cpr.common.message": "translation-tr.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-tr.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-tr.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-tr.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-tr.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-tr.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-tr.json"
	},
	"tr-TR": {
		"com.amazon.lens.cpr.common.common": "translation-tr.json",
		"com.amazon.lens.cpr.common.menu": "translation-tr.json",
		"com.amazon.lens.cpr.common.message": "translation-tr.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-tr.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-tr.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-tr.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-tr.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-tr.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-tr.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-tr.json"
	},
	und: {
		"com.amazon.lens.cpr.common.common": "translation.json",
		"com.amazon.lens.cpr.common.menu": "translation.json",
		"com.amazon.lens.cpr.common.message": "translation.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation.json",
		"com.amazon.lens.cpr.pages.caseList": "translation.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation.json",
		"com.amazon.lens.cpr.pages.createCase": "translation.json"
	},
	vi: {
		"com.amazon.lens.cpr.common.common": "translation-vi.json",
		"com.amazon.lens.cpr.common.menu": "translation-vi.json",
		"com.amazon.lens.cpr.common.message": "translation-vi.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-vi.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-vi.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-vi.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-vi.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-vi.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-vi.json"
	},
	"vi-VN": {
		"com.amazon.lens.cpr.common.common": "translation-vi.json",
		"com.amazon.lens.cpr.common.menu": "translation-vi.json",
		"com.amazon.lens.cpr.common.message": "translation-vi.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-vi.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-vi.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-vi.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-vi.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-vi.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-vi.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-vi.json"
	},
	zh: {
		"com.amazon.lens.cpr.common.common": "translation-zh.json",
		"com.amazon.lens.cpr.common.menu": "translation-zh.json",
		"com.amazon.lens.cpr.common.message": "translation-zh.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-zh.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-zh.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-zh.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-zh.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-zh.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-zh.json"
	},
	"zh-CN": {
		"com.amazon.lens.cpr.common.common": "translation-zh.json",
		"com.amazon.lens.cpr.common.menu": "translation-zh.json",
		"com.amazon.lens.cpr.common.message": "translation-zh.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-zh.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-zh.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-zh.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-zh.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-zh.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-zh.json"
	},
	"zh-TW": {
		"com.amazon.lens.cpr.common.common": "translation-zh.json",
		"com.amazon.lens.cpr.common.menu": "translation-zh.json",
		"com.amazon.lens.cpr.common.message": "translation-zh.json",
		"com.amazon.lens.cpr.components.fileUploader": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.csam.csam": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.gts.gts": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.product-safety.productSafety": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.sustainability.landingPage": "translation-zh.json",
		"com.amazon.lens.cpr.ddm.sustainability.socialResponsibility": "translation-zh.json",
		"com.amazon.lens.cpr.pages.caseDetails": "translation-zh.json",
		"com.amazon.lens.cpr.pages.caseList": "translation-zh.json",
		"com.amazon.lens.cpr.pages.caseSummary": "translation-zh.json",
		"com.amazon.lens.cpr.pages.communicationPage": "translation-zh.json",
		"com.amazon.lens.cpr.pages.createCase": "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
